import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var SettingsComponent = (function () {
    function SettingsComponent(apiService, modalService, router, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.router = router;
        this.translate = translate;
        this.autoSend = true;
        this.manualSendDay = 15;
        this.selectedValue = '';
        this.confirmPassword = '';
        this.passwordErrorMessage = null;
        this.updateSettingsMessage = null;
    }
    SettingsComponent.prototype.ngOnInit = function () {
        this.getSettings();
    };
    SettingsComponent.prototype.getSettings = function () {
        var _this = this;
        this.apiService.getSettings().subscribe(function (result) {
            // check that result is not empty
            if (Object.keys(result).length !== 0 || result.constructor !== Object) {
                _this.autoSend = result.auto_send.is_active;
                _this.manualSendDay = result.auto_send.default_send_date;
                if (_this.autoSend === false) {
                    _this.selectedValue = 'manualSend';
                    document.getElementById('manualSendDaySelectBox').disabled = false;
                }
                else {
                    _this.selectedValue = 'autoSend';
                    document.getElementById('manualSendDaySelectBox').disabled = true;
                }
            }
        }, function (error) {
        });
    };
    SettingsComponent.prototype.save = function (content) {
        this.confirmPassword = '';
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
    };
    SettingsComponent.prototype.cancel = function () {
        this.confirmPassword = '';
        this.router.navigate(['/dashboard']);
    };
    SettingsComponent.prototype.closeConfirmSettingsBox = function () {
        this.modal.close();
    };
    SettingsComponent.prototype.confirmSaveSettingsBox = function (content) {
        // close save settings box
        this.modal.close();
        // open confirm save settings box
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
    };
    SettingsComponent.prototype.closePasswordBox = function () {
        this.modal.close();
    };
    SettingsComponent.prototype.enterPasswordBox = function (content) {
        var _this = this;
        this.passwordErrorMessage = null;
        this.apiService.confirmPassword({
            confirm_password: this.confirmPassword,
        }).subscribe(function (result) {
            if (result.success === true) {
                _this.updateSettingsHelper(content);
            }
            else {
                if (_this.translate.currentLang === 'en') {
                    _this.passwordErrorMessage = 'Password is incorrect';
                }
                else {
                    _this.passwordErrorMessage = 'รหัสผ่านไม่ตรงกัน';
                }
            }
        }, function (error) {
            if (_this.translate.currentLang === 'en') {
                _this.passwordErrorMessage = 'Password is incorrect';
            }
            else {
                _this.passwordErrorMessage = 'รหัสผ่านไม่ตรงกัน';
            }
        });
    };
    SettingsComponent.prototype.closeSavedSuccessfullyBox = function () {
        this.confirmPassword = '';
        this.modal.close();
    };
    SettingsComponent.prototype.updateSettingsHelper = function (content) {
        var _this = this;
        this.updateSettingsMessage = null;
        if (this.selectedValue === 'manualSend') {
            this.autoSend = false;
        }
        else if (this.selectedValue === 'autoSend') {
            this.autoSend = true;
        }
        var params = {
            autoSend: this.autoSend,
            manualSendDay: this.manualSendDay
        };
        this.apiService.updateSettings(params).subscribe(function (result) {
            if (_this.translate.currentLang === 'en') {
                _this.updateSettingsMessage = 'Saved successfully!';
            }
            else {
                _this.updateSettingsMessage = 'บันทึกสำเร็จ';
            }
            // close password box
            _this.modal.close();
            // open update settings status box
            _this.modal = _this.modalService.open(content, { backdrop: 'static', keyboard: false, centered: true });
        }, function (error) {
            if (_this.translate.currentLang === 'en') {
                _this.updateSettingsMessage = 'Settings not saved';
            }
            else {
                _this.updateSettingsMessage = 'บันทึกไม่สำเร็จ';
            }
        });
        this.sniff('UPDATE_SETTINGS', 'autoSend: ' + params.autoSend
            + ', manualSendDay: ' + params.manualSendDay);
    };
    SettingsComponent.prototype.onItemChange = function () {
        if (this.selectedValue === 'autoSend') {
            document.getElementById('manualSendDaySelectBox').disabled = true;
        }
        else if (this.selectedValue === 'manualSend') {
            document.getElementById('manualSendDaySelectBox').disabled = false;
        }
    };
    SettingsComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'SETTINGS',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return SettingsComponent;
}());
export { SettingsComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.ts.pre-build-optimizer.js